import { useViewport } from "@/hooks";
import { Text } from "@/includes";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Stack, Tooltip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import EvolutionMetricSelector from "../EvolutionMetricSelector";
import { HeaderProps } from "./types";
import CardLabel from "@/components/_Molecules/_NewComponents/CardLabel";

const Header = ({
  compare,
  filters,
  experienceName,
  evolutionMetric,
  setEvolutionMetric,
  isComparaison = false,
}: HeaderProps) => {
  const { startDate, endDate } = filters;
  const { isMobile } = useViewport();
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      <Stack
        direction={isMobile ? "column" : "row"}
        justifyContent="space-between"
        sx={{ width: "100%" }}
        spacing={1}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="flex-start"
          sx={{ maxWidth: `calc(100% - ${theme.spacing(40)})` }}
        >
          <CardLabel
            label={
              compare ? `${t("evolution")} - ${experienceName}` : t("evolution")
            }
            help={
              !!startDate && !!endDate
                ? `${t("data_period_tooltip")} ${startDate} ${t(
                    "to"
                  )} ${endDate}`
                : ""
            }
          />
        </Stack>
        <EvolutionMetricSelector
          evolutionKey={evolutionMetric}
          handleChange={setEvolutionMetric}
          isComparaison={isComparaison}
        />
      </Stack>
    </Stack>
  );
};

export default Header;
